import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [aktifKullanici, setAktifKullanici] = useState(() => {
    const saved = localStorage.getItem('stok_kullanici');
    return saved ? JSON.parse(saved) : null;
  });

  useEffect(() => {
    const handleOturumKapat = () => {
      localStorage.removeItem('stok_token');
      localStorage.removeItem('stok_kullanici');
      setAktifKullanici(null);
    };
    window.addEventListener('stok_oturum_kapat', handleOturumKapat);
    return () => window.removeEventListener('stok_oturum_kapat', handleOturumKapat);
  }, []);

  const girisYap = async (kullaniciAdi, sifre) => {
    try {
      const data = await api.post('/api/auth/login', { kullanici_adi: kullaniciAdi, sifre });
      localStorage.setItem('stok_token', data.access_token);
      localStorage.setItem('stok_kullanici', JSON.stringify(data.kullanici));
      setAktifKullanici(data.kullanici);
      return { basarili: true };
    } catch (e) {
      return { basarili: false, hata: e.message };
    }
  };

  const cikisYap = () => {
    localStorage.removeItem('stok_token');
    localStorage.removeItem('stok_kullanici');
    setAktifKullanici(null);
  };

  const kullaniciEkle = (yeni) => api.post('/api/kullanicilar', {
    kullanici_adi: yeni.kullaniciAdi,
    sifre: yeni.sifre,
    ad: yeni.ad,
    rol: yeni.rol,
  });

  const kullaniciSil = (id) => api.del(`/api/kullanicilar/${id}`);

  const sifreGuncelle = (id, yeniSifre) => api.put(`/api/kullanicilar/${id}/sifre`, { yeni_sifre: yeniSifre });

  const rolGuncelle = (id, rol) => api.put(`/api/kullanicilar/${id}/rol`, { rol });

  const kullanicilariGetir = () => api.get('/api/kullanicilar');

  return (
    <AuthContext.Provider value={{
      aktifKullanici,
      girisYap,
      cikisYap,
      kullaniciEkle,
      kullaniciSil,
      sifreGuncelle,
      rolGuncelle,
      kullanicilariGetir,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
